import { useI18n } from "@excalidraw/excalidraw/i18n";
import { ExcalicoLogo, WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();
  const headingContent = (
    <div className="welcome-screen-center__description">
      <div className="welcome-screen-center__headline">
        {t("welcomeScreen.app.center_heading")}
      </div>
      <div className="welcome-screen-center__subhead">
        {t("welcomeScreen.app.center_heading_line2")}
      </div>
      <div className="welcome-screen-center__tagline">
        {t("welcomeScreen.app.center_heading_line3")}
      </div>
    </div>
  );

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint>
        {t("welcomeScreen.app.toolbarHint")}
      </WelcomeScreen.Hints.ToolbarHint>
      <WelcomeScreen.Hints.HelpHint>
        {t("welcomeScreen.app.helpHint")}
      </WelcomeScreen.Hints.HelpHint>
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo>
          <div className="welcome-screen-center__brand">
            <ExcalicoLogo withText size="normal" />
          </div>
        </WelcomeScreen.Center.Logo>
        <WelcomeScreen.Center.Heading>
          {headingContent}
        </WelcomeScreen.Center.Heading>
        <WelcomeScreen.Center.Menu>
          <WelcomeScreen.Center.MenuItemLoadScene />
          <WelcomeScreen.Center.MenuItemHelp />
          {props.isCollabEnabled && (
            <WelcomeScreen.Center.MenuItemLiveCollaborationTrigger
              onSelect={() => props.onCollabDialogOpen()}
            />
          )}
        </WelcomeScreen.Center.Menu>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
